export const UPDATE_DATA_RETENTION_SETTINGS = 'UPDATE_DATA_RETENTION_SETTINGS';
export const UPDATE_DATA_RETENTION_SETTINGS_SUCCESS = 'UPDATE_DATA_RETENTION_SETTINGS_SUCCESS';
export const UPDATE_DATA_RETENTION_SETTINGS_ERROR = 'UPDATE_DATA_RETENTION_SETTINGS_ERROR';
